import React from "react";
import { Box, Divider } from "@mui/material";
import CheckoutCartCard from "./CheckoutCartCard";
import { useCart } from "../../context/cart-context";
// import { getUserDetails } from "../../firebase/firebaseAuth";
// import { updateDocument } from "../../firebase/firebaseCrud";

export const CheckoutProductList = () => {
  // const [address, setAddress] = React.useState("");

  const { cart } = useCart();

  return (
    <React.Fragment>
      <Box as="div" className=" md:w-3/4 w-full mx-auto">
        {/* <Box as="div" className="w-3/4 mx-auto"> */}

        <Box className="my-8">
          {cart &&
            cart.map((item, index) => (
              <Box key={index}>
                <CheckoutCartCard key={index} data={item} />
                <Divider className="" />
              </Box>
            ))}
        </Box>
      </Box>
    </React.Fragment>
  );
};
